import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['message'];

  // Fires on initial connect and again when a loaded preset replaces the
  // textarea via turbo stream, which produces no input event.
  messageTargetConnected() {
    queueMicrotask(() => this.#notifyPresets());
  }

  messageChanged() {
    this.#notifyPresets();
  }

  #notifyPresets() {
    this.dispatch('messageChanged', { detail: { message: this.messageTarget.value } });
  }
}
